  <img height="75" src="https://www.flacriminallawyer.com/wp-content/uploads/2015/12/Fort-Lauderdale-Criminal-Attorney-Jonathan-Friedman-Logo.jpg" />
<br /><br />

<div *ngIf="caseDetails" class="case-details-section">
  <h4>Case Information</h4>
  <div class="case-info-card">
    <div class="info-row">
      <label>Case Number:</label>
      <span>{{ caseDetails.CaseDetails?.CaseNumber || 'N/A' }}</span>
    </div>
    <div class="info-row">
      <label>Court Type:</label>
      <span>{{ caseDetails.CaseDetails?.CourtType || 'N/A' }}</span>
    </div>
    <div class="info-row">
      <label>Case Type:</label>
      <span>{{ caseDetails.CaseDetails?.CaseType || 'N/A' }}</span>
    </div>
    <div class="info-row">
      <label>Judge:</label>
      <span>{{ caseDetails.CaseDetails?.Judge || 'N/A' }}</span>
    </div>
    <div class="info-row">
      <label>Defendant:</label>
      <span>{{ caseDetails.CaseDetails?.Defendant || 'N/A' }}</span>
    </div>
  </div>
</div>

<div *ngIf="busyLoading">Stand by... reading some law books....</div>

<div *ngIf="!busyLoading">
  <h3>
    Auto Brief Generator</h3>

    <br />
    <table>
      <tr>
        <td>Template:</td>
        <td>
          <select [(ngModel)]="templateId">
          <option *ngFor="let t of templates" value="{{t.id}}">{{t.name}}</option>
          </select>
          <span *ngIf="templates.length == 0" style="color: red;">You need at least one Google Doc with the word "Template" in the name.</span>
        </td>
      </tr>
      <tr>
        <td>Client Name</td>
        <td><input type="text" style="width: 500px;"  /></td>
      </tr>
      <tr>
        <td>Body</td>
        <td><textarea [(ngModel)]="body" rows="6" style="width: 500px;" [(ngModel)]="briefBody"></textarea></td>
        <td><input type="checkbox" [(ngModel)]="useAi" id="ai" name="ai" /><label for="ai">This is a prompt. Use AI.</label></td>
      </tr>
      <tr>
        <td></td>
        <td></td>
      </tr>
    </table>
      <br /><br />

  <div>
    <!-- <a href="/jfriedman/generatedocument">Generate a Sample Document</a> -->
    <button [disabled]="busyGenerate || templateId.length == 0 || briefBody.length == 0" (click)="generateDocument($event)">Generate Brief</button>

    <div *ngIf="busyGenerate">GENERATING... standby... the AI is furiously typing...</div>
    <br /><br />
    <div *ngIf="briefLink">
    Link to your new document: <a target="_blank" [href]="briefLink">{{briefLink}}</a>
    </div>
    
  </div>
  
<div>



  <br /><br /><br /><br /><br /><br /><br />
</div>
